module.exports = __webpack_public_path__ + "img/attachment.e56ffb5a.svg";